import { Patient } from "@/Common/Models/Patient/Patient";
import { DirectoryHealthCareProvider } from "../Models/DirectoryHealthCareProvider";
import { PharmacyProxy } from "../Models/PharmacyProxy";

export class DirectoryPatientLinksHelper {
    public static getPreferredPharmacy(patientContactId: string): PharmacyProxy {
        if (!patientContactId)
            return null;

        const model = patientStore.PatientModels?.[patientContactId];
        const preferredPharmacy = model?.PreferredPharmacy;
        const pharmacyInfo = preferredPharmacy?.getPharmacyInfo();

        if (!pharmacyInfo)
            return null;

        const isEmptyModel = [
            pharmacyInfo.Banner,
            pharmacyInfo.Name,
            pharmacyInfo.Address,
            pharmacyInfo.Fax
        ].all(p => IsNullOrWhiteSpace(p));

        return !isEmptyModel
            ? preferredPharmacy
            : null;
    }

    public static getExternalConsultants(patientContactId: string): DirectoryHealthCareProvider[] {
        if (!patientContactId)
            return [];

        const intervenors = patientStore.PatientProfileCliniciansModels?.[patientContactId]
            ?.get("IntervenorsOnFile")
            ?.toArray();

        return intervenors
            ?.filter(p => p?.Model?.HealthCareProvider)
            .map(p => DirectoryHealthCareProvider.fromPatientRefIntervenor(p.Model))
            ?? [];
    }

    public static getFromPatientModel(patient: Patient): { preferredPharmacy: PharmacyProxy, externalConsultants: DirectoryHealthCareProvider[] } {
        return {
            preferredPharmacy: patient.PreferredPharmacy,
            externalConsultants: patient.IntervenorsOnFile
                .map(p => DirectoryHealthCareProvider.fromPatientRefIntervenor(p.Model))
                .filter(p => !!p)
        };
    }
}
